import { UserRoles } from 'src/types/user';

export const authorizedRoles = [
  UserRoles.superAdmin, UserRoles.clientAdmin, UserRoles.storeManager, UserRoles.floorManager, UserRoles.clerk,UserRoles.clerkCashOrders,UserRoles.tunnelManager
];

export const checkRolesForAccess = (roles: UserRoles[]) => roles.some(v => authorizedRoles.includes(v));